import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAVEL = {
  nickname: 'PRODUCTS.TRAVEL.shortname',
  properties: [
    {
      name: 'travelSingleTripExtensionMonths', key: 'TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.0', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.3', value: '3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.4', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.5', value: '5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.6', value: '6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.7', value: '7' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.8', value: '8' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.9', value: '9' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_SINGLE_TRIP_EXTENSION_MONTHS.10', value: '10' },
        ]
      }
    },
    {
      name: 'travelNumberOfInsuredPersons', key: 'TRAVEL_NUMBER_OF_INSURED_PERSONS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.3', value: '3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.4', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.5', value: '5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.6', value: '6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.7', value: '7' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.8', value: '8' },
        ]
      }
    },
  ],
  icon: 'travel'
};
